<script>
	import DashboardItem from "../components/DashboardItem/DashboardItem.svelte";
	import { onMount } from "svelte";
	import { userName, userRole, masterData } from "../store/store";
	import client from "../services/client";
	import { getMasterData } from "../services/profile";

	// onMount(async () => {
	// 	const masterdata = await getMasterData()
	// 	masterData.set(masterdata.data.data)

	// 	// console.log($masterData.carParks);
	// })
</script>

<div class="dashboard-container">
	<DashboardItem
		title="Active/Onboarded Vehicle Info"
		items={[
			{
				subtitle: "Active Vehicles",
				num: 5000,
			},
			{
				subtitle: "On-boarded Vehicles",
				num: 15000,
			},
		]}
	/>
	<DashboardItem
		title="Cars to Action"
		items={[
			{
				subtitle: "Unmaintained for 5 days",
				num: 5000,
			},
			{
				subtitle: "Battery < 10%",
				num: 50,
			},
			{
				subtitle: "Fuel < 20%",
				num: 10,
			},
		]}
	/>
	<DashboardItem
		title="G.E.T"
		items={[
			{
				subtitle: "Active Personnel",
				num: 5000,
			},
			{
				subtitle: "Pending Personnel",
				num: 50,
			},
		]}
	/>
	<DashboardItem
		title="Workshop"
		items={[
			{
				subtitle: "Vehicles in Workshop",
				num: 250,
			},
			{
				subtitle: "Sent > 7 days ago",
				num: 50,
			},
		]}
	/>
</div>
